/**
 * Authenticated fetch wrapper.
 * Drop-in replacement for fetch() that automatically adds
 * the Authorization: Bearer header — but ONLY for requests
 * to our own backend, not external APIs.
 *
 * Also intercepts 401 responses from our own API and redirects
 * to the login page, clearing stale credentials from localStorage.
 *
 * IMPORTANT: Auth endpoints (/api/auth/*) are excluded from this
 * auto-redirect behavior because 401 is an expected response for
 * invalid credentials during login/reset flows.
 */
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.bjmpmedicast.com';

// Guard against multiple concurrent 401s triggering multiple redirects
let isRedirectingToLogin = false;

export default async function authFetch(url, options = {}) {
  const urlStr = typeof url === 'string' ? url : url.toString();
  const isOwnApi = urlStr.startsWith(API_BASE_URL) || urlStr.startsWith('http://localhost:8000');
  const isAuthEndpoint = /\/api\/auth\//i.test(urlStr);

  if (isOwnApi) {
    const token = localStorage.getItem('token');
    if (token) {
      options.headers = {
        ...options.headers,
        'Authorization': `Bearer ${token}`,
      };
    }
  }

  const response = await fetch(url, options);

  if (isOwnApi && !isAuthEndpoint && response.status === 401 && !isRedirectingToLogin) {
    isRedirectingToLogin = true;
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/';
  }

  return response;
}
